/* ============================================================
   DIVANOSO — Badge "Risparmi €X" sotto il prodotto (drawer iCart)
   v2.1 — pillola su riga singola (11.5px, nowrap)
   Sostituisce la riga aggregata "Oggi risparmi..." (nascosta
   via CSS: .icart .icart-saving-text-left { display:none !important; })
   ------------------------------------------------------------
   INSTALLAZIONE: sostituisce INTEGRALMENTE il contenuto di
   Assets/risparmio-badge.js. La riga in theme.liquid resta quella:
   <script src="{{ 'risparmio-badge.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var COMPARE_SELECTOR = '.icart .icart-product-compare-price';
  var BADGE_CLASS = 'dv-risparmio-badge';

  function parseEuro(str) {
    var s = str.replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var sepPos = Math.max(lastDot, lastComma);
    if (sepPos === -1) return parseFloat(s);
    var decimals = s.length - sepPos - 1;
    if (decimals === 3) return parseFloat(s.replace(/[.,]/g, ''));
    return parseFloat(
      s.slice(0, sepPos).replace(/[.,]/g, '') + '.' + s.slice(sepPos + 1)
    );
  }

  function allEuros(txt) {
    var m = txt.match(/€\s*[\d.,]+/g);
    if (!m) return [];
    return m.map(parseEuro).filter(function (n) { return n > 0; });
  }

  function formatEuro(n) {
    return '\u20AC' + Math.round(n).toLocaleString('it-IT');
  }

  /* risale dal prezzo barrato al contenitore riga:
     il primo antenato con almeno 2 importi € distinti */
  function findRow(el) {
    var node = el.parentElement;
    var hops = 0;
    while (node && hops < 6) {
      var vals = allEuros(node.textContent || '');
      var distinct = vals.filter(function (v, i) {
        return vals.indexOf(v) === i;
      });
      if (distinct.length >= 2) return node;
      node = node.parentElement;
      hops++;
    }
    return null;
  }

  function render() {
    document.querySelectorAll(COMPARE_SELECTOR).forEach(function (cmpEl) {
      if (cmpEl.offsetParent === null) return; /* solo visibili */

      var cmp = parseEuro(cmpEl.textContent || '');
      if (!(cmp > 0)) return;

      var row = findRow(cmpEl);
      if (!row) return;

      /* prezzo attuale = il piu' piccolo importo della riga
         diverso dal barrato (esclude il testo del badge stesso) */
      var badge = row.querySelector('.' + BADGE_CLASS);
      var rowText = row.textContent || '';
      if (badge) rowText = rowText.replace(badge.textContent, '');

      var current = null;
      allEuros(rowText).forEach(function (v) {
        if (v < cmp && (current === null || v < current)) current = v;
      });
      if (!(current > 0)) return;

      var saving = cmp - current;
      if (!(saving > 0)) return;

      var text = 'Risparmi ' + formatEuro(saving);

      if (!badge) {
        badge = document.createElement('div');
        badge.className = BADGE_CLASS;
        badge.style.cssText =
          'display:inline-block;margin-top:5px;padding:2px 9px;' +
          'background:#E6F7F1;color:#00875F;font-size:11.5px;' +
          'font-weight:700;border-radius:11px;line-height:1.4;' +
          'font-family:Arial,Helvetica,sans-serif;' +
          'white-space:nowrap;';
        row.appendChild(badge);
      }
      if (badge.textContent !== text) badge.textContent = text;
    });
  }

  var t = null;
  var observer = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(render, 150);
  });

  function start() {
    render();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();